// @flow

import type { EasyAction } from '../../type'

import * as React from 'react'

type Props = {
  convertId: string
};

window.dataLayer = window.dataLayer || []

function gtag () {
  window.dataLayer.push(arguments)
}

export default class Toutiao extends React.PureComponent<Props> {
  static actions: EasyAction[] = [
    {
      title: '记录注册事件',
      name: 'pushEvent'
    }
  ];

  componentWillMount () {
    loadAdCode()
  }

  actionPushEvent = (data: void) => {
    // $FlowFixMe
    gtag('event', 'conversion', {
      send_to: 'AW-844137732/qtcYCPudqIABEISKwpID',
      event_callback: function () {}
    })
  };

  render () {
    return null
  }
}

function loadAdCode () {
  /* eslint-disable */
  var ta = document.createElement('script');
  ta.type = 'text/javascript';
  ta.async = true;
  ta.src = 'https://www.googletagmanager.com/gtag/js?id=AW-844137732';
  var s = document.getElementsByTagName('script')[0];
  // $FlowFixMe
  s.parentNode.insertBefore(ta, s);

  // $FlowFixMe
  gtag('js', new Date());
  // $FlowFixMe
  gtag('config', 'AW-844137732');
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/Admob.js